export const PATH_DATA_ATTRIBUTE = 'data-cr-content-path';
export const CONTENT_DATA_ATTRIBUTE = 'data-cr-content';
export const WINDOW_DATA_PROPERTY_NAME = '__WTR_CR_DATA__';
